export default {
  "info": "questionnaire registre vasculites",
  "children": [
    {
      "id": "1",
      "label": "Antécédents",
      "index": 1,
      "children": [
        {
          "id": "2",
          "label": ".",
          "index": 1,
          "children": [
            {
              "id": "3",
              "label": "Données démographiques",
              "index": 1,
              "children": [
                {
                  "id": "5400",
                  "timeRule": "d1,d2;d1>d2",
                  "index": 1,
                  "tab": "Antécédents",
                  "category": ".",
                  "subCategory": "Données démographiques",
                  "name": "Emploi",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date de fin",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date de fin"
                    },
                    {
                      "label": "Emploi",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Emploi"
                    }
                  ]
                },
                {
                  "id": "5500",
                  "timeRule": null,
                  "index": 2,
                  "tab": "Antécédents",
                  "category": ".",
                  "subCategory": "Données démographiques",
                  "name": "Ethnie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "",
                  "isMultiple": false,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Ethnie",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "caucasien",
                        "noir",
                        "asiatique",
                        "hispanique",
                        "premières nations",
                        "autres"
                      ],
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Ethnie"
                    }
                  ]
                },
                {
                  "id": "5600",
                  "timeRule": "d2,d3;d2>d3",
                  "index": 3,
                  "tab": "Antécédents",
                  "category": ".",
                  "subCategory": "Données démographiques",
                  "name": "Code Postal",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d2",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Code postal (3 premiers caractères)",
                      "type": "text",
                      "unit": "",
                      "choice": "CODEPOSTAL",
                      "key": "d1",
                      "typeRules": "errorIfFormatInvalid",
                      "fieldName": "Code postal (3 premiers caracteres)"
                    },
                    {
                      "label": "Début de résidence",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Debut de residence"
                    },
                    {
                      "label": "Date de fin de résidence",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date de fin de residence"
                    }
                  ]
                }
              ]
            },
            {
              "id": "4",
              "label": "Habitudes de vie",
              "index": 4,
              "children": [
                {
                  "id": "5700",
                  "timeRule": "d1,d2;d1>d2",
                  "index": 4,
                  "tab": "Antécédents",
                  "category": ".",
                  "subCategory": "Habitudes de vie",
                  "name": "Tabagisme",
                  "labelItem": "Ajouter une rechute",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Paquets/semaine",
                      "type": "nombre",
                      "unit": "nombre",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Paquets/semaine"
                    }
                  ]
                },
                {
                  "id": "5800",
                  "timeRule": "d1,d2;d1>d2",
                  "index": 5,
                  "tab": "Antécédents",
                  "category": ".",
                  "subCategory": "Habitudes de vie",
                  "name": "Alcool",
                  "labelItem": "Ajouter une rechute",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Consommation/semaine",
                      "type": "nombre",
                      "unit": "nombre",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Consommation/semaine"
                    }
                  ]
                },
                {
                  "id": "5900",
                  "timeRule": "d1,d2;d1>d2",
                  "index": 6,
                  "tab": "Antécédents",
                  "category": ".",
                  "subCategory": "Habitudes de vie",
                  "name": "Cannabis",
                  "labelItem": "Ajouter une rechute",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Consommation/semaine",
                      "type": "nombre",
                      "unit": "nombre",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Consommation/semaine"
                    }
                  ]
                },
                {
                  "id": "6000",
                  "timeRule": "d1,d2;d1>d2",
                  "index": 7,
                  "tab": "Antécédents",
                  "category": ".",
                  "subCategory": "Habitudes de vie",
                  "name": "Crack",
                  "labelItem": "Ajouter une rechute",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Consommation/semaine",
                      "type": "nombre",
                      "unit": "nombre",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Consommation/semaine"
                    }
                  ]
                },
                {
                  "id": "6100",
                  "timeRule": "d1,d2;d1>d2",
                  "index": 8,
                  "tab": "Antécédents",
                  "category": ".",
                  "subCategory": "Habitudes de vie",
                  "name": "Cocaïne",
                  "labelItem": "Ajouter une rechute",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Consommation/semaine",
                      "type": "nombre",
                      "unit": "nombre",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Consommation/semaine"
                    }
                  ]
                },
                {
                  "id": "6200",
                  "timeRule": "d1,d2",
                  "index": 9,
                  "tab": "Antécédents",
                  "category": ".",
                  "subCategory": "Habitudes de vie",
                  "name": "Autre",
                  "labelItem": "Ajouter une rechute",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Spécifiez le produit",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez le produit"
                    },
                    {
                      "label": "Consommation/semaine",
                      "type": "nombre",
                      "unit": "nombre",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Consommation/semaine"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "5",
          "label": "Antécédents familiaux",
          "index": 10,
          "children": [
            {
              "id": "6",
              "label": "Familial",
              "index": 10,
              "children": [
                {
                  "id": "3900",
                  "timeRule": null,
                  "index": 10,
                  "tab": "Antécédents",
                  "category": "Antécédents familiaux",
                  "subCategory": "Familial",
                  "name": "Maladies pulmonaires",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Lien parental",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "Mère",
                        "Père",
                        "Frère",
                        "Soeur",
                        "Grand-mère",
                        "Grand-père",
                        "Autre"
                      ],
                      "key": "d2",
                      "typeRules": "",
                      "fieldName": "Lien parental"
                    },
                    {
                      "label": "Nom de la maladie pulmonaires",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la maladie pulmonaires"
                    }
                  ]
                },
                {
                  "id": "4000",
                  "timeRule": null,
                  "index": 11,
                  "tab": "Antécédents",
                  "category": "Antécédents familiaux",
                  "subCategory": "Familial",
                  "name": "MCAS",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Lien parental",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "Mère",
                        "Père",
                        "Frère",
                        "Soeur",
                        "Grand-mère",
                        "Grand-père",
                        "Autre"
                      ],
                      "key": "d2",
                      "typeRules": "",
                      "fieldName": "Lien parental"
                    }
                  ]
                },
                {
                  "id": "4100",
                  "timeRule": null,
                  "index": 12,
                  "tab": "Antécédents",
                  "category": "Antécédents familiaux",
                  "subCategory": "Familial",
                  "name": "MVAS",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Lien parental",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "Mère",
                        "Père",
                        "Frère",
                        "Soeur",
                        "Grand-mère",
                        "Grand-père",
                        "Autre"
                      ],
                      "key": "d2",
                      "typeRules": "",
                      "fieldName": "Lien parental"
                    }
                  ]
                },
                {
                  "id": "4200",
                  "timeRule": null,
                  "index": 13,
                  "tab": "Antécédents",
                  "category": "Antécédents familiaux",
                  "subCategory": "Familial",
                  "name": "Hypertension artérielle ",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Lien parental",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "Mère",
                        "Père",
                        "Frère",
                        "Soeur",
                        "Grand-mère",
                        "Grand-père",
                        "Autre"
                      ],
                      "key": "d2",
                      "typeRules": "",
                      "fieldName": "Lien parental"
                    }
                  ]
                },
                {
                  "id": "4300",
                  "timeRule": null,
                  "index": 14,
                  "tab": "Antécédents",
                  "category": "Antécédents familiaux",
                  "subCategory": "Familial",
                  "name": "Diabète",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Lien parental",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "Mère",
                        "Père",
                        "Frère",
                        "Soeur",
                        "Grand-mère",
                        "Grand-père",
                        "Autre"
                      ],
                      "key": "d2",
                      "typeRules": "",
                      "fieldName": "Lien parental"
                    }
                  ]
                },
                {
                  "id": "4400",
                  "timeRule": null,
                  "index": 15,
                  "tab": "Antécédents",
                  "category": "Antécédents familiaux",
                  "subCategory": "Familial",
                  "name": "Dyslipidémie ",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Lien parental",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "Mère",
                        "Père",
                        "Frère",
                        "Soeur",
                        "Grand-mère",
                        "Grand-père",
                        "Autre"
                      ],
                      "key": "d2",
                      "typeRules": "",
                      "fieldName": "Lien parental"
                    }
                  ]
                },
                {
                  "id": "4500",
                  "timeRule": null,
                  "index": 16,
                  "tab": "Antécédents",
                  "category": "Antécédents familiaux",
                  "subCategory": "Familial",
                  "name": "Psoriasis",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Lien parental",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "Mère",
                        "Père",
                        "Frère",
                        "Soeur",
                        "Grand-mère",
                        "Grand-père",
                        "Autre"
                      ],
                      "key": "d2",
                      "typeRules": "",
                      "fieldName": "Lien parental"
                    }
                  ]
                },
                {
                  "id": "4600",
                  "timeRule": null,
                  "index": 17,
                  "tab": "Antécédents",
                  "category": "Antécédents familiaux",
                  "subCategory": "Familial",
                  "name": "Autre",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Lien parental",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "Mère",
                        "Père",
                        "Frère",
                        "Soeur",
                        "Grand-mère",
                        "Grand-père",
                        "Autre"
                      ],
                      "key": "d2",
                      "typeRules": "",
                      "fieldName": "Lien parental"
                    },
                    {
                      "label": "Nom de la maladie",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la maladie"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "7",
          "label": "Antécédents personels",
          "index": 18,
          "children": [
            {
              "id": "8",
              "label": "Cardiovasculaire",
              "index": 18,
              "children": [
                {
                  "id": "100",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 18,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Cardiovasculaire",
                  "name": "MCAS",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "200",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 19,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Cardiovasculaire",
                  "name": "Insuffisance cardiaque",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "300",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 20,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Cardiovasculaire",
                  "name": "MVAS",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "400",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 21,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Cardiovasculaire",
                  "name": "Hypertension artérielle ",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "500",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 22,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Cardiovasculaire",
                  "name": "Dyslipidémie ",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "600",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 23,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Cardiovasculaire",
                  "name": "Revascularisation",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "700",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 24,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Cardiovasculaire",
                  "name": "ACV / ICT",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "800",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 25,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Cardiovasculaire",
                  "name": "Autre",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez la maladie cardiovasculaire",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez la maladie cardiovasculaire"
                    }
                  ]
                }
              ]
            },
            {
              "id": "9",
              "label": "Pulmonaire",
              "index": 26,
              "children": [
                {
                  "id": "900",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 26,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Pulmonaire",
                  "name": "MPOC",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "1000",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 27,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Pulmonaire",
                  "name": "Asthme",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "1100",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 28,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Pulmonaire",
                  "name": "Bronchiectasies",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "1200",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 29,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Pulmonaire",
                  "name": "Pneumopathie interstitielle",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "1300",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 30,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Pulmonaire",
                  "name": "Autre",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez la maladie pulmonaire",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez la maladie pulmonaire"
                    }
                  ]
                }
              ]
            },
            {
              "id": "10",
              "label": "Gastrointestinal et hépatobiliaire",
              "index": 31,
              "children": [
                {
                  "id": "1400",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 31,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Gastrointestinal et hépatobiliaire",
                  "name": "Ulcère peptique",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "1500",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 32,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Gastrointestinal et hépatobiliaire",
                  "name": "Hépatite infectieuse",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "1600",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 33,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Gastrointestinal et hépatobiliaire",
                  "name": "Pancréatite",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "1700",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 34,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Gastrointestinal et hépatobiliaire",
                  "name": "Hémorragie digestive",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "1800",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 35,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Gastrointestinal et hépatobiliaire",
                  "name": "Diverticulose /diverticulite",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "5100",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 36,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Gastrointestinal et hépatobiliaire",
                  "name": "Maladies intestinales inflammatoires",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "1900",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 37,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Gastrointestinal et hépatobiliaire",
                  "name": "Autre",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez la maladie gastrointestinal et hépatobiliaire",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez la maladie gastrointestinal et hepatobiliaire"
                    }
                  ]
                }
              ]
            },
            {
              "id": "11",
              "label": "Rénal",
              "index": 38,
              "children": [
                {
                  "id": "2000",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 38,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Rénal",
                  "name": "insuffisance rénale ",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Stade",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "1",
                        "2",
                        "3A",
                        "3B",
                        "4",
                        "5"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Stade"
                    }
                  ]
                },
                {
                  "id": "2100",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 39,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Rénal",
                  "name": "Autre",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez la maladie rénal",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez la maladie renal"
                    }
                  ]
                }
              ]
            },
            {
              "id": "12",
              "label": "Endocrinien",
              "index": 40,
              "children": [
                {
                  "id": "2200",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 40,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Endocrinien",
                  "name": "Hypothyroïdie",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "2300",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 41,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Endocrinien",
                  "name": "HyperthyroÏdie",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "2400",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 42,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Endocrinien",
                  "name": "Diabète",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "2500",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 43,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Endocrinien",
                  "name": "Hyperparathyroïdie",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "2600",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 44,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Endocrinien",
                  "name": "Autre",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez la maladie endocrinienne",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez la maladie endocrinienne"
                    }
                  ]
                }
              ]
            },
            {
              "id": "13",
              "label": "Neurologique",
              "index": 45,
              "children": [
                {
                  "id": "2700",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 45,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Neurologique",
                  "name": "Migraine",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "2800",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 46,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Neurologique",
                  "name": "Accident vasculaire cérébral",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "2900",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 47,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Neurologique",
                  "name": "Autre",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez la maladie neurologique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez la maladie neurologique"
                    }
                  ]
                }
              ]
            },
            {
              "id": "14",
              "label": "Hématologique",
              "index": 48,
              "children": [
                {
                  "id": "3000",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 48,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Hématologique",
                  "name": "Maladie de Hodgkin",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "3100",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 49,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Hématologique",
                  "name": "Lymphome non Hodgkinien",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "5200",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 50,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Hématologique",
                  "name": "Maladies hématologiques immunes (leucopénie, anémie, thrombopénie)",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "3200",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 51,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Hématologique",
                  "name": "Autre",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez la maladie hématologique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez la maladie hematologique"
                    }
                  ]
                }
              ]
            },
            {
              "id": "15",
              "label": "Peau",
              "index": 52,
              "children": [
                {
                  "id": "3300",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 52,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Peau",
                  "name": "Psoriasis",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "3400",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 53,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Peau",
                  "name": "Néoplasie",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Région affecté par la néoplasie",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "système nerveux",
                        "poumons",
                        "sein",
                        "peau",
                        "gastrointestinal",
                        "rein",
                        "vessie",
                        "uterus",
                        "ovaires",
                        "testicules",
                        "prostate",
                        "ORL",
                        "thyroïde",
                        "foie",
                        "pancreas",
                        "hématologique",
                        "lymphoprolifératif",
                        "autre"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Region affecte par la neoplasie"
                    }
                  ]
                },
                {
                  "id": "3500",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 54,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Peau",
                  "name": "Autre",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez la maladie de la peau",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez la maladie de la peau"
                    }
                  ]
                }
              ]
            },
            {
              "id": "16",
              "label": "Problème musculosquelettique",
              "index": 55,
              "children": [
                {
                  "id": "3600",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 55,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Problème musculosquelettique",
                  "name": "Arthropathies inflammatoires arthrite rhumatoïde",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "4800",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 56,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Problème musculosquelettique",
                  "name": "Arthropathies inflammatoires spondylarthropathies séronégatives",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "3700",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 57,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Problème musculosquelettique",
                  "name": "Ostéoporose",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Fracturaire ou non",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "fracturaire",
                        "non fracturaire"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Fracturaire ou non"
                    }
                  ]
                },
                {
                  "id": "3800",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 58,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Problème musculosquelettique",
                  "name": "Autre",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez le problème musculosquelettique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez le probleme musculosquelettique"
                    }
                  ]
                }
              ]
            },
            {
              "id": "17",
              "label": "Maladie immunologiques",
              "index": 59,
              "children": [
                {
                  "id": "4900",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 59,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Maladie immunologiques",
                  "name": "Collagénoses",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "5000",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 60,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Maladie immunologiques",
                  "name": "Vasculites",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "5300",
                  "timeRule": "d2,d1,d3;d1>d3",
                  "index": 61,
                  "tab": "Antécédents",
                  "category": "Antécédents personels",
                  "subCategory": "Maladie immunologiques",
                  "name": "Autre",
                  "labelItem": "Ajouter un autre cas",
                  "labelVisit": "Ajouter une note",
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Date début des symptômes",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Nom de la maladie immunologiques",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la maladie immunologiques"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "18",
      "label": "Vasculite",
      "index": 62,
      "children": [
        {
          "id": "19",
          "label": "Manifestations cliniques",
          "index": 62,
          "children": [
            {
              "id": "20",
              "label": "Général",
              "index": 62,
              "children": [
                {
                  "id": "6400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 62,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Général",
                  "name": "Fièvre plus de 38,0",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "6500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 63,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Général",
                  "name": "Perte de poids plus de 2 kg",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "6600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 64,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Général",
                  "name": "Baisse de l’état général",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                }
              ]
            },
            {
              "id": "21",
              "label": "Musculosquelettique",
              "index": 65,
              "children": [
                {
                  "id": "6700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 65,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Musculosquelettique",
                  "name": "Arthralgies",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "6800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 66,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Musculosquelettique",
                  "name": "Myalgies",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "6900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 67,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Musculosquelettique",
                  "name": "Polymyalgia rhumatica",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "7000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 68,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Musculosquelettique",
                  "name": "Gonflement articulaire",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "7100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 69,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Musculosquelettique",
                  "name": "Myosite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "7200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 70,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Musculosquelettique",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez"
                    }
                  ]
                }
              ]
            },
            {
              "id": "22",
              "label": "Peau",
              "index": 71,
              "children": [
                {
                  "id": "7300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 71,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Peau",
                  "name": "Purpura",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "7400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 72,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Peau",
                  "name": "Vésicule",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "7500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 73,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Peau",
                  "name": "Bulle",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "7600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 74,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Peau",
                  "name": "Pustule",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "7700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 75,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Peau",
                  "name": "Ischémie digitale /gangrène",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "7800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 76,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Peau",
                  "name": "Erythème noueux",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "7900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 77,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Peau",
                  "name": "Nodule cutané",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "8000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 78,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Peau",
                  "name": "Hémorragie en flamèche",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "8100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 79,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Peau",
                  "name": "Livedo",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "8200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 80,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Peau",
                  "name": "Ulcère",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "8300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 81,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Peau",
                  "name": "Pyoderma gangrenosum",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "8400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 82,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Peau",
                  "name": "Autres",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez"
                    }
                  ]
                }
              ]
            },
            {
              "id": "23",
              "label": "Ophtalomologique",
              "index": 83,
              "children": [
                {
                  "id": "8500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 83,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Ophtalomologique",
                  "name": "Baisse/perte de la vue/embrouillement visuel",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "8600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 84,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Ophtalomologique",
                  "name": "Diplopie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "8700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 85,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Ophtalomologique",
                  "name": "Douleur",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "8800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 86,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Ophtalomologique",
                  "name": "Conjonctivite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "8900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 87,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Ophtalomologique",
                  "name": "Uvéite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "9000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 88,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Ophtalomologique",
                  "name": "Kératite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "9100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 89,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Ophtalomologique",
                  "name": "Sclérite/épisclérite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "9200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 90,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Ophtalomologique",
                  "name": "Neuropathie optique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "9300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 91,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Ophtalomologique",
                  "name": "Rétinopathie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "9400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 92,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Ophtalomologique",
                  "name": "Proptose",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "9500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 93,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Ophtalomologique",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez"
                    }
                  ]
                }
              ]
            },
            {
              "id": "24",
              "label": "ORL",
              "index": 94,
              "children": [
                {
                  "id": "9600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 94,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Hypoacousie : conduction",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "9700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 95,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Hypoacousie : neurosensorielle",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "9800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 96,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Vertiges",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "9900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 97,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Acouphène",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "10000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 98,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Congestion nasale",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "10100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 99,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Atteinte sinusale",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "10200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 100,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Ecoulement",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "10300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 101,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Epistaxis",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "10400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 102,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Croûtes",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "10500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 103,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Chondrite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "10600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 104,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Dysphonie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "10700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 105,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Claudication mâchoire",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "10800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 106,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Sténose sous-glottique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "10900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 107,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Inflammation annexes (glandes)",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "11000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 108,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "ORL",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez"
                    }
                  ]
                }
              ]
            },
            {
              "id": "25",
              "label": "Pulmonaire",
              "index": 109,
              "children": [
                {
                  "id": "11100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 109,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Pulmonaire",
                  "name": "Toux",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "11200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 110,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Pulmonaire",
                  "name": "Dyspnée",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "11300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 111,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Pulmonaire",
                  "name": "Douleur pleurétique / effusion pleurale",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "11400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 112,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Pulmonaire",
                  "name": "Asthme /sibilances",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "11500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 113,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Pulmonaire",
                  "name": "Hémoptysie importante",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "11600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 114,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Pulmonaire",
                  "name": "Nodules pulmonaires",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "11700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 115,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Pulmonaire",
                  "name": "Hémorragie alvéolaire",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "11800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 116,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Pulmonaire",
                  "name": "Infiltrats",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "11900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 117,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Pulmonaire",
                  "name": "Anomalies fonctions respiratoires",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "12000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 118,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Pulmonaire",
                  "name": "Atteinte endobronchique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "12100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 119,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Pulmonaire",
                  "name": "Insuffisance respiratoire requérant intubation",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "12200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 120,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Pulmonaire",
                  "name": "Autres",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez"
                    }
                  ]
                }
              ]
            },
            {
              "id": "26",
              "label": "Cardiovasculaire",
              "index": 121,
              "children": [
                {
                  "id": "12300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 121,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Cardiovasculaire",
                  "name": "Douleur cardiaque ischémique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "12400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 122,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Cardiovasculaire",
                  "name": "Insuffisance cardiaque",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "12500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 123,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Cardiovasculaire",
                  "name": "Atteinte vasculitique macrovasculaire périphérique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "12600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 124,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Cardiovasculaire",
                  "name": "Valvulopathie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "12700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 125,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Cardiovasculaire",
                  "name": "Péricardite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "12800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 126,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Cardiovasculaire",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez"
                    }
                  ]
                }
              ]
            },
            {
              "id": "27",
              "label": "Gastrointestinal",
              "index": 127,
              "children": [
                {
                  "id": "12900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 127,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Gastrointestinal",
                  "name": "Hématémèse",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "13000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 128,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Gastrointestinal",
                  "name": "Rectorragie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "13100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 129,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Gastrointestinal",
                  "name": "Melena",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "13200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 130,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Gastrointestinal",
                  "name": "Ulcères buccaux",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "13300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 131,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Gastrointestinal",
                  "name": "Perforation",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "13400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 132,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Gastrointestinal",
                  "name": "Pancréatite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "13500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 133,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Gastrointestinal",
                  "name": "Douleur sur ischémie mésentérique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "13600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 134,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Gastrointestinal",
                  "name": "Diarrhée",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "13700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 135,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Gastrointestinal",
                  "name": "Péritonite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "13800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 136,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Gastrointestinal",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez"
                    }
                  ]
                }
              ]
            },
            {
              "id": "28",
              "label": "Génitourinaire",
              "index": 137,
              "children": [
                {
                  "id": "13900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 137,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Génitourinaire",
                  "name": "Protéinurie supérieure à 1+ ou P:C plus de 0,2",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Quantité",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "plus de 0,2g",
                        "plus de 0,5g",
                        "plus de 1g",
                        "plus de 3g"
                      ],
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Quantite"
                    }
                  ]
                },
                {
                  "id": "14000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 138,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Génitourinaire",
                  "name": "Hématurie modérée ou 10 GR/champ ou plus",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "14100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 139,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Génitourinaire",
                  "name": "Élévation de créatinine plus de 30% / diminution du DFG plus 25%",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Élévation créatinine > 30%",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Elevation creatinine > 30%"
                    },
                    {
                      "label": "Créatinine (nombre en umol/L)",
                      "type": "nombre",
                      "unit": "nombre",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Creatinine (nombre en umol/L)"
                    },
                    {
                      "label": "Diminution du DFG > 25%",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Diminution du DFG > 25%"
                    },
                    {
                      "label": "DFG estimé (cc/min)",
                      "type": "nombre",
                      "unit": "nombre",
                      "choice": "",
                      "key": "d6",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "DFG estime (cc/min)"
                    }
                  ]
                },
                {
                  "id": "14200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 140,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Génitourinaire",
                  "name": "Cylindres hématiques",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "14300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 141,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Génitourinaire",
                  "name": "Dialyse",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "14400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 142,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Génitourinaire",
                  "name": "Hypertension (diastolique supérieure à95)",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "14500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 143,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Génitourinaire",
                  "name": "Ulcères génitaux",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "14600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 144,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Génitourinaire",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez"
                    }
                  ]
                }
              ]
            },
            {
              "id": "29",
              "label": "Métabolique",
              "index": 145,
              "children": [
                {
                  "id": "14700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 145,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Métabolique",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez"
                    }
                  ]
                }
              ]
            },
            {
              "id": "30",
              "label": "Neurologique",
              "index": 146,
              "children": [
                {
                  "id": "14800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 146,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Neurologique",
                  "name": "Atteinte méningée",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "14900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 147,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Neurologique",
                  "name": "Vasculite cérébrale",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "15000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 148,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Neurologique",
                  "name": "Céphalée",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "15100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 149,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Neurologique",
                  "name": "Thrombose sinus veineux Cérébrite/encéphalopathie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "15200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 150,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Neurologique",
                  "name": "Accident vasculaire cérébral",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "15300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 151,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Neurologique",
                  "name": "Confusion organique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "15400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 152,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Neurologique",
                  "name": "Myélopathie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "15500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 153,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Neurologique",
                  "name": "Polyneuropathie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "15600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 154,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Neurologique",
                  "name": "Mononévrite multiplex",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "15700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 155,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Neurologique",
                  "name": "Convulsions",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "15800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 156,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Neurologique",
                  "name": "Neuropathie crânienne",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date début des symptômes",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date debut des symptomes"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    }
                  ]
                },
                {
                  "id": "15900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 157,
                  "tab": "Vasculite",
                  "category": "Manifestations cliniques",
                  "subCategory": "Neurologique",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "entrée",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date rémission",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif",
                      "fieldName": "Date remission"
                    },
                    {
                      "label": "Spécifiez",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifiez"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "31",
      "label": "Médications",
      "index": 158,
      "children": [
        {
          "id": "32",
          "label": "Médications",
          "index": 158,
          "children": [
            {
              "id": "33",
              "label": "Immunomodulateurs",
              "index": 158,
              "children": [
                {
                  "id": "16000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 158,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "Corticoïdes  (équivalent prednisone ou prednisolone)",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "16100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 159,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "Cyclophosphamide",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "16200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 160,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "Azathioprine",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "16300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 161,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "Methotrexate",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/semaine",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "16400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 162,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "Mycophenolate mofetil",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "16500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 163,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "Leflunomide",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "16600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 164,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "Rituximab",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "choix_multiples",
                      "unit": "mg/cycle",
                      "choice": [
                        "375 mg / m2 X 4",
                        "500 mg J1 et J15",
                        "500 mg",
                        "1000 mg J1 et J15",
                        "1000 mg",
                        "autre"
                      ],
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    },
                    {
                      "label": "Fréquence d’administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "chaque mois",
                        "aux 6 mois",
                        "aux années",
                        "autre"
                      ],
                      "key": "d6",
                      "typeRules": "",
                      "fieldName": "Frequence d’administration"
                    }
                  ]
                },
                {
                  "id": "16700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 165,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "Abatacept",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    },
                    {
                      "label": "Fréquence d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "chaque semaine",
                        "chaque mois",
                        "autre"
                      ],
                      "key": "d6",
                      "typeRules": "",
                      "fieldName": "Frequence d'administration"
                    }
                  ]
                },
                {
                  "id": "16800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 166,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "Tocilizumab",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    },
                    {
                      "label": "Fréquence d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "par semaine",
                        "par 2 semaines",
                        "par mois"
                      ],
                      "key": "d6",
                      "typeRules": "",
                      "fieldName": "Frequence d'administration"
                    }
                  ]
                },
                {
                  "id": "16900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 167,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "Ustekinumab",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    },
                    {
                      "label": "",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "par 3 mois",
                        "autre"
                      ],
                      "key": "d6",
                      "typeRules": "",
                      "fieldName": ""
                    }
                  ]
                },
                {
                  "id": "17000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 168,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "Inhibiteur de JaK",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "17100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 169,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "IVIG",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "g/",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    },
                    {
                      "label": "Fréquence d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "semaine",
                        "mois",
                        "autre"
                      ],
                      "key": "d6",
                      "typeRules": "",
                      "fieldName": "Frequence d'administration"
                    }
                  ]
                },
                {
                  "id": "17200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 170,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Immunomodulateurs",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                }
              ]
            },
            {
              "id": "34",
              "label": "Cardiovasculaire",
              "index": 171,
              "children": [
                {
                  "id": "17300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 171,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Cardiovasculaire",
                  "name": "Anticoagulants",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "17400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 172,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Cardiovasculaire",
                  "name": "Antiplaquettaires",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "17500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 173,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Cardiovasculaire",
                  "name": "Statines",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "17600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 174,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Cardiovasculaire",
                  "name": "IECA",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "17700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 175,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Cardiovasculaire",
                  "name": "ARA",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "17800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 176,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Cardiovasculaire",
                  "name": "Bloqueurs canaux calciques",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "17900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 177,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Cardiovasculaire",
                  "name": "Beta bloquants",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "18000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 178,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Cardiovasculaire",
                  "name": "Diurétiques",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "18100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 179,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Cardiovasculaire",
                  "name": "Hypotenseurs autres",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "18200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 180,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Cardiovasculaire",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                }
              ]
            },
            {
              "id": "35",
              "label": "Respiratoire",
              "index": 181,
              "children": [
                {
                  "id": "18300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 181,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Respiratoire",
                  "name": "Stéroïdes inhalés",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "18400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 182,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Respiratoire",
                  "name": "Bronchodilatateurs",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "18500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 183,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Respiratoire",
                  "name": "Inhibiteurs de leukotriènes",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "18600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 184,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Respiratoire",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                }
              ]
            },
            {
              "id": "36",
              "label": "Gastrointestinal",
              "index": 185,
              "children": [
                {
                  "id": "18700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 185,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Gastrointestinal",
                  "name": "Inhibiteurs de la pompe à protons",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "18800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 186,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Gastrointestinal",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                }
              ]
            },
            {
              "id": "37",
              "label": "Endocrinien",
              "index": 187,
              "children": [
                {
                  "id": "18900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 187,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Endocrinien",
                  "name": "Insuline",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "unités/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "19000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 188,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Endocrinien",
                  "name": "Hypoglycémiants oraux",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "19100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 189,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Endocrinien",
                  "name": "Hormonothérapie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "19200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 190,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Endocrinien",
                  "name": "Thyroxine",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "19300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 191,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Endocrinien",
                  "name": "Anti thyroïdiens (ex. PTU)",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "19400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 192,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Endocrinien",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                }
              ]
            },
            {
              "id": "38",
              "label": "Infectieux",
              "index": 193,
              "children": [
                {
                  "id": "19500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 193,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Infectieux",
                  "name": "Antibiotiques prophylactiques",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Catégorie",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "TMP/SMX",
                        "pentamidine",
                        "dapsone",
                        "atovaquone",
                        "acyclovir",
                        "valacyclovir",
                        "famcyclovir",
                        "autre"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Categorie"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d6",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "19600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 194,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Infectieux",
                  "name": "Antibiothérapie (infection active)",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "19700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 195,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Infectieux",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                }
              ]
            },
            {
              "id": "39",
              "label": "Ostéoporose",
              "index": 196,
              "children": [
                {
                  "id": "19800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 196,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Ostéoporose",
                  "name": "Vitamine D",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "Unités/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "19900",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 197,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Ostéoporose",
                  "name": "Antirésorptifs",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Type",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bisphosphonates",
                        "denosumab",
                        "raloxifène",
                        "oestrogènes"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/dose",
                      "choice": "",
                      "key": "d6",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "20000",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 198,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Ostéoporose",
                  "name": "Agent anabolique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "20100",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 199,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Ostéoporose",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                }
              ]
            },
            {
              "id": "40",
              "label": "Produits naturels",
              "index": 200,
              "children": [
                {
                  "id": "20200",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 200,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Produits naturels",
                  "name": "Produit naturel",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "20300",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 201,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Produits naturels",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                }
              ]
            },
            {
              "id": "41",
              "label": "Dermatologie",
              "index": 202,
              "children": [
                {
                  "id": "20400",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 202,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Dermatologie",
                  "name": "StéroÏdes topiques",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "20500",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 203,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Dermatologie",
                  "name": "Inhibiteurs de calcineurine topiques",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "20600",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 204,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Dermatologie",
                  "name": "Dapsone",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "20700",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 205,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Dermatologie",
                  "name": "Colchicine",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                },
                {
                  "id": "20800",
                  "timeRule": "dV,d1|d1,d2;d1>d2",
                  "index": 206,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Dermatologie",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "médication",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de début",
                      "type": "dateD",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date de debut"
                    },
                    {
                      "label": "Date d'arrêt",
                      "type": "dateF",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "hintIfAbsent,toujours actif:futureOk",
                      "fieldName": "Date d'arret"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Voie d'administration",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "PO",
                        "SC",
                        "IM",
                        "IV"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Voie d'administration"
                    },
                    {
                      "label": "Posologie",
                      "type": "nombre",
                      "unit": "mg/jour",
                      "choice": "",
                      "key": "d5",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Posologie"
                    }
                  ]
                }
              ]
            },
            {
              "id": "42",
              "label": "Vaccins",
              "index": 207,
              "children": [
                {
                  "id": "20900",
                  "timeRule": null,
                  "index": 207,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "Inluenza",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    }
                  ]
                },
                {
                  "id": "21000",
                  "timeRule": null,
                  "index": 208,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "Pneumocoque",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    },
                    {
                      "label": "Type",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "prevnar 20",
                        "prevnar 13",
                        "pneumovax"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type"
                    }
                  ]
                },
                {
                  "id": "21100",
                  "timeRule": null,
                  "index": 209,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "H influenzae",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    }
                  ]
                },
                {
                  "id": "21200",
                  "timeRule": null,
                  "index": 210,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "Hépatite A",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    }
                  ]
                },
                {
                  "id": "21300",
                  "timeRule": null,
                  "index": 211,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "Hépatite B",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    }
                  ]
                },
                {
                  "id": "21400",
                  "timeRule": null,
                  "index": 212,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "Herpes zoster (zona)",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    },
                    {
                      "label": "Type",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "zostavax",
                        "shingrix"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type"
                    }
                  ]
                },
                {
                  "id": "21500",
                  "timeRule": null,
                  "index": 213,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "Varicelle",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    }
                  ]
                },
                {
                  "id": "21600",
                  "timeRule": null,
                  "index": 214,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "N meningitidis",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    }
                  ]
                },
                {
                  "id": "21700",
                  "timeRule": null,
                  "index": 215,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "Papilloma virus",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    }
                  ]
                },
                {
                  "id": "21800",
                  "timeRule": null,
                  "index": 216,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "Fièvre jaune",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    }
                  ]
                },
                {
                  "id": "21900",
                  "timeRule": null,
                  "index": 217,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "DCT",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    }
                  ]
                },
                {
                  "id": "22000",
                  "timeRule": null,
                  "index": 218,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "MMR",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    }
                  ]
                },
                {
                  "id": "22100",
                  "timeRule": null,
                  "index": 219,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "Tetanos",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    }
                  ]
                },
                {
                  "id": "22200",
                  "timeRule": null,
                  "index": 220,
                  "tab": "Médications",
                  "category": "Médications",
                  "subCategory": "Vaccins",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date de vaccination",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date de vaccination"
                    },
                    {
                      "label": "Nom du vaccin",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom du vaccin"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "43",
      "label": "Comorbidités",
      "index": 221,
      "children": [
        {
          "id": "44",
          "label": "Infection",
          "index": 221,
          "children": [
            {
              "id": "45",
              "label": "Cutané",
              "index": 221,
              "children": [
                {
                  "id": "22300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 221,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Cutané",
                  "name": "Cellulite, abcès, furonculose",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "46",
              "label": "ORLO",
              "index": 222,
              "children": [
                {
                  "id": "22400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 222,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "ORLO",
                  "name": "Oreilles",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "22500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 223,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "ORLO",
                  "name": "Sinus",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "22600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 224,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "ORLO",
                  "name": "Nez",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "22700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 225,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "ORLO",
                  "name": "Oeil",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "22800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 226,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "ORLO",
                  "name": "Pharynx/Larynx",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "22900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 227,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "ORLO",
                  "name": "Bouche / gencives",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "47",
              "label": "Respiratoire",
              "index": 228,
              "children": [
                {
                  "id": "23000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 228,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Respiratoire",
                  "name": "Voies respiratoires inférieures",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "23100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 229,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Respiratoire",
                  "name": "Bronchiectasies",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "23200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 230,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Respiratoire",
                  "name": "Cavité pleurale",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "48",
              "label": "Cardiovasculaire",
              "index": 231,
              "children": [
                {
                  "id": "23300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 231,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Cardiovasculaire",
                  "name": "Endocarde",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "23400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 232,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Cardiovasculaire",
                  "name": "Myocarde",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "23500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 233,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Cardiovasculaire",
                  "name": "Péricarde",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "23600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 234,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Cardiovasculaire",
                  "name": "Vaisseaux sanguins",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "49",
              "label": "Digestif",
              "index": 235,
              "children": [
                {
                  "id": "23700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 235,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Digestif",
                  "name": "Oesophage/estomac",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "23800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 236,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Digestif",
                  "name": "Entérite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "23900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 237,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Digestif",
                  "name": "Colite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "24000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 238,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Digestif",
                  "name": "Foie et voies biliaires",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "50",
              "label": "Urogénital",
              "index": 239,
              "children": [
                {
                  "id": "24100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 239,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Urogénital",
                  "name": "Pyélonéphrite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "24200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 240,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Urogénital",
                  "name": "Organes génitaux",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "24300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 241,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Urogénital",
                  "name": "Cystite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "24400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 242,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Urogénital",
                  "name": "Uréthrite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "24500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 243,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Urogénital",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Nom de l'endroit anatomique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de l'endroit anatomique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "51",
              "label": "Système nerveux",
              "index": 244,
              "children": [
                {
                  "id": "24600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 244,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Système nerveux",
                  "name": "Cerveau",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "24700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 245,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Système nerveux",
                  "name": "Méninges",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "24800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 246,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Système nerveux",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Nom de l'endroit anatomique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de l'endroit anatomique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "52",
              "label": "Musculosquelettique",
              "index": 247,
              "children": [
                {
                  "id": "24900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 247,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Musculosquelettique",
                  "name": "Articulations",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "25000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 248,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Musculosquelettique",
                  "name": "Os",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "25100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 249,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Musculosquelettique",
                  "name": "Tendons",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "25200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 250,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Musculosquelettique",
                  "name": "Fascia",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "25300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 251,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Musculosquelettique",
                  "name": "Muscles",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "25400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 252,
                  "tab": "Comorbidités",
                  "category": "Infection",
                  "subCategory": "Musculosquelettique",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Type de microorganismes",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "bactérien",
                        "mycobactérien",
                        "mycose",
                        "parasite",
                        "viral"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Type de microorganismes"
                    },
                    {
                      "label": "Nom de l'endroit anatomique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de l'endroit anatomique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d4",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "53",
          "label": "Néoplasie",
          "index": 253,
          "children": [
            {
              "id": "54",
              "label": "Cutanée",
              "index": 253,
              "children": [
                {
                  "id": "25500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 253,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Cutanée",
                  "name": "Mélanome",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "25600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 254,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Cutanée",
                  "name": "Non Mélanome",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "55",
              "label": "Système nerveux central",
              "index": 255,
              "children": [
                {
                  "id": "25700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 255,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Système nerveux central",
                  "name": "Système nerveux central",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "56",
              "label": "ORLO",
              "index": 256,
              "children": [
                {
                  "id": "25800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 256,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "ORLO",
                  "name": "ORLO",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "57",
              "label": "Cardiovasculaire",
              "index": 257,
              "children": [
                {
                  "id": "25900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 257,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Cardiovasculaire",
                  "name": "Cardiovasculaire",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "58",
              "label": "Hématologique",
              "index": 258,
              "children": [
                {
                  "id": "26000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 258,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Hématologique",
                  "name": "Leucémie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "26100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 259,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Hématologique",
                  "name": "Lymphome",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "26200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 260,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Hématologique",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de l'endroit anatomique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de l'endroit anatomique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "59",
              "label": "Respiratoire",
              "index": 261,
              "children": [
                {
                  "id": "26300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 261,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Respiratoire",
                  "name": "Poumon",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "26400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 262,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Respiratoire",
                  "name": "Plèvre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "26500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 263,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Respiratoire",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de l'endroit anatomique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de l'endroit anatomique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "60",
              "label": "Gastrointestinal",
              "index": 264,
              "children": [
                {
                  "id": "26600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 264,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Gastrointestinal",
                  "name": "Oesophage",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "26700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 265,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Gastrointestinal",
                  "name": "Estomac",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "26800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 266,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Gastrointestinal",
                  "name": "Intestin grêle",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "26900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 267,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Gastrointestinal",
                  "name": "Colon",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "27000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 268,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Gastrointestinal",
                  "name": "Foie et voies biliaires",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "27100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 269,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Gastrointestinal",
                  "name": "Pancréas",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "27200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 270,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Gastrointestinal",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de l'endroit anatomique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de l'endroit anatomique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "61",
              "label": "Endocrinien",
              "index": 271,
              "children": [
                {
                  "id": "27300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 271,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Endocrinien",
                  "name": "Thyroïde",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "27400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 272,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Endocrinien",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de l'endroit anatomique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de l'endroit anatomique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "62",
              "label": "Sein",
              "index": 273,
              "children": [
                {
                  "id": "27500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 273,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Sein",
                  "name": "Sein",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "63",
              "label": "Génito urinaire",
              "index": 274,
              "children": [
                {
                  "id": "27600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 274,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Génito urinaire",
                  "name": "Spécifier",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "64",
              "label": "Autre",
              "index": 275,
              "children": [
                {
                  "id": "27700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 275,
                  "tab": "Comorbidités",
                  "category": "Néoplasie",
                  "subCategory": "Autre",
                  "name": "Spécifier",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom du type de néoplasie",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom du type de neoplasie"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "65",
          "label": "Autres comorbidités",
          "index": 276,
          "children": [
            {
              "id": "66",
              "label": "Endocrino-métabolique",
              "index": 276,
              "children": [
                {
                  "id": "27800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 276,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Endocrino-métabolique",
                  "name": "Diabète",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "27900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 277,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Endocrino-métabolique",
                  "name": "Hypocorticisme",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "28000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 278,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Endocrino-métabolique",
                  "name": "Hypercorticisme",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "28100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 279,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Endocrino-métabolique",
                  "name": "Hypothyroïdie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "28200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 280,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Endocrino-métabolique",
                  "name": "Hyperthyroïdie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "28300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 281,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Endocrino-métabolique",
                  "name": "Dyslipidémie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "28400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 282,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Endocrino-métabolique",
                  "name": "Hypogonadisme",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "28500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 283,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Endocrino-métabolique",
                  "name": "Obésité",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "28600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 284,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Endocrino-métabolique",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de la comorbidités endocrino-métabolique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la comorbidites endocrino-metabolique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "67",
              "label": "Os",
              "index": 285,
              "children": [
                {
                  "id": "28700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 285,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Os",
                  "name": "Ostéoporose",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Fracturaire ou non",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "fracturaire",
                        "non fracturaire"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Fracturaire ou non"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "28800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 286,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Os",
                  "name": "Nécrose avasculaire",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "28900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 287,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Os",
                  "name": "Ostéomalacie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "29000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 288,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Os",
                  "name": "Fracture atypique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "29100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 289,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Os",
                  "name": "Fracture",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "29200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 290,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Os",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de la comorbidités de l'os",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la comorbidites de l'os"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "68",
              "label": "Cardiovasculaire",
              "index": 291,
              "children": [
                {
                  "id": "29300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 291,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Cardiovasculaire",
                  "name": "MCAS",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Infarctus du myocarde (oui / non)",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "oui",
                        "non"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Infarctus du myocarde (oui / non)"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "29400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 292,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Cardiovasculaire",
                  "name": "MVAS",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "29500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 293,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Cardiovasculaire",
                  "name": "Hypertension",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "29600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 294,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Cardiovasculaire",
                  "name": "Insuffisance cardiaque",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "FEVG si disponible",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "FEVG si disponible"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "29700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 295,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Cardiovasculaire",
                  "name": "Sténose de gros vaisseaux, asymétrie de pouls ou de pression",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    },
                    {
                      "label": "Région Anatomique",
                      "type": "choix_multiple_non_ex",
                      "unit": "",
                      "choice": [
                        "aorte ascendante",
                        "crosse aortique",
                        "aorte descendante",
                        "aorte abdominale",
                        "carotide",
                        "tronc innominé",
                        "sous-clavière",
                        "artère axillaire",
                        "artère brachiale",
                        "artère ulnaire",
                        "artère radiale",
                        "artère digitale",
                        "tronc coeliaque",
                        "artère mésentérique supérieure",
                        "artère mésentérique inférieure",
                        "artère iliaque",
                        "artère fémorale",
                        "artère poplitée",
                        "artère péronière",
                        "artère tibiale postérieure",
                        "autre"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Region Anatomique"
                    }
                  ]
                },
                {
                  "id": "29800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 296,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Cardiovasculaire",
                  "name": "Anévrisme",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    },
                    {
                      "label": "Région Anatomique",
                      "type": "choix_multiple_non_ex",
                      "unit": "",
                      "choice": [
                        "aorte ascendante",
                        "crosse aortique",
                        "aorte descendante",
                        "aorte abdominale",
                        "carotide",
                        "tronc innominé",
                        "sous-clavière",
                        "artère axillaire",
                        "artère brachiale",
                        "artère ulnaire",
                        "artère radiale",
                        "artère digitale",
                        "tronc coeliaque",
                        "artère mésentérique supérieure",
                        "artère mésentérique inférieure",
                        "artère iliaque",
                        "artère fémorale",
                        "artère poplitée",
                        "artère péronière",
                        "artère tibiale postérieure",
                        "autre"
                      ],
                      "key": "d4",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Region Anatomique"
                    }
                  ]
                },
                {
                  "id": "29900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 297,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Cardiovasculaire",
                  "name": "Thrombose veineuse",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Préciser emplacement si connu",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Preciser emplacement si connu"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "30000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 298,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Cardiovasculaire",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de la comorbidités cardiovasculaire",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la comorbidites cardiovasculaire"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "69",
              "label": "ORLO",
              "index": 299,
              "children": [
                {
                  "id": "30100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 299,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "ORLO",
                  "name": "Cataractes",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "30200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 300,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "ORLO",
                  "name": "Cécité",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "30300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 301,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "ORLO",
                  "name": "Perte audition",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "30400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 302,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "ORLO",
                  "name": "Perforation septum nasal ou autre structure os/cartilage",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "30500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 303,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "ORLO",
                  "name": "Sténose sous glottique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "30600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 304,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "ORLO",
                  "name": "Glaucome",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "30700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 305,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "ORLO",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de la comorbidités ORLO",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la comorbidites ORLO"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "70",
              "label": "Respiratoire",
              "index": 306,
              "children": [
                {
                  "id": "30800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 306,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Respiratoire",
                  "name": "Pneumopathie interstitielle",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "30900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 307,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Respiratoire",
                  "name": "Embolie pulmonaire",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "31000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 308,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Respiratoire",
                  "name": "MPOC",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "31100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 309,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Respiratoire",
                  "name": "Hypertension pulmonaire",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "31200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 310,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Respiratoire",
                  "name": "Dommage pleural (ex: fibrose)",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "31300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 311,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Respiratoire",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de la comorbidités respiratoire",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la comorbidites respiratoire"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "71",
              "label": "neurologique",
              "index": 312,
              "children": [
                {
                  "id": "31400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 312,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "neurologique",
                  "name": "AVC / ICT",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "31500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 313,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "neurologique",
                  "name": "Déclin cognitif",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "31600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 314,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "neurologique",
                  "name": "Myélopathie chronique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "31700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 315,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "neurologique",
                  "name": "Neuropathie périphérique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "31800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 316,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "neurologique",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "72",
              "label": "Digestif",
              "index": 317,
              "children": [
                {
                  "id": "31900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 317,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Digestif",
                  "name": "Ulcus peptique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "32000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 318,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Digestif",
                  "name": "Ischémie / infarctus mésentérique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "32100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 319,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Digestif",
                  "name": "Perforation",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "32200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 320,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Digestif",
                  "name": "Diverticulite",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "32300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 321,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Digestif",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de la comorbidités digestive",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la comorbidites digestive"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "73",
              "label": "Urogénital",
              "index": 322,
              "children": [
                {
                  "id": "32400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 322,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Urogénital",
                  "name": "Insuffisance rénale chronique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "1 (DFG Sup 90)",
                        "2 (DFG 61-89)",
                        "3a (DFG 46-60)",
                        "3b (DFG 31-44)",
                        "4 (DFG 16-29)",
                        "5 (DFG inf 15)"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "32500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 323,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Urogénital",
                  "name": "Dialyse chronique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "32600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 324,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Urogénital",
                  "name": "Greffe rénale",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "32700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 325,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Urogénital",
                  "name": "Cystite hémorragique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "32800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 326,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Urogénital",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de la comorbidités urogénital",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la comorbidites urogenital"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "74",
              "label": "Dermatologique",
              "index": 327,
              "children": [
                {
                  "id": "32900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 327,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Dermatologique",
                  "name": "Alopécie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "33000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 328,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Dermatologique",
                  "name": "Ulcère cutané",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "33100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 329,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Dermatologique",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de la comorbidités dermatologique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la comorbidites dermatologique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "75",
              "label": "Musculosqulettique",
              "index": 330,
              "children": [
                {
                  "id": "33200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 330,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Musculosqulettique",
                  "name": "Myopathie stéroïdienne",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "33300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 331,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Musculosqulettique",
                  "name": "Atrophie musculaire",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "76",
              "label": "Hématologique",
              "index": 332,
              "children": [
                {
                  "id": "33400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 332,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Hématologique",
                  "name": "Hypogammaglobulinémie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                },
                {
                  "id": "33500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 333,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Hématologique",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de la comorbidités hématologique",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la comorbidites hematologique"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "77",
              "label": "Nouvelle maladie autoimmune",
              "index": 334,
              "children": [
                {
                  "id": "33600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 334,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Nouvelle maladie autoimmune",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du diagnostique",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du diagnostique"
                    },
                    {
                      "label": "Nom de la comorbidités autoimmune",
                      "type": "text",
                      "unit": "",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Nom de la comorbidites autoimmune"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            },
            {
              "id": "78",
              "label": "Mortalité",
              "index": 335,
              "children": [
                {
                  "id": "33700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 335,
                  "tab": "Comorbidités",
                  "category": "Autres comorbidités",
                  "subCategory": "Mortalité",
                  "name": "Mort",
                  "labelItem": "NO_BUTTON",
                  "labelVisit": null,
                  "orderByField": "",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du décès",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Date du deces"
                    },
                    {
                      "label": "Spécifier cause si connue",
                      "type": "choix_multiple_non_ex",
                      "unit": "",
                      "choice": [
                        "Vasculite",
                        "infectieux",
                        "néoplasie",
                        "neurologique",
                        "cardiovasculaire",
                        "embolie pulmonaire",
                        "digestif",
                        "insuffisance rénale",
                        "hypertension",
                        "hémorragie",
                        "respiratoire",
                        "cause iatrogène"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Specifier cause si connue"
                    },
                    {
                      "label": "Hospitalisé",
                      "type": "boolean",
                      "unit": "",
                      "choice": "",
                      "key": "d3",
                      "typeRules": "",
                      "fieldName": "Hospitalise"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "79",
      "label": "Examens paracliniques",
      "index": 336,
      "children": [
        {
          "id": "80",
          "label": "Examens de laboratoire",
          "index": 336,
          "children": [
            {
              "id": "81",
              "label": "Hématologie",
              "index": 336,
              "children": [
                {
                  "id": "33800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 336,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Hématologie",
                  "name": "Globules blancs totaux",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "10exp9 / litre",
                      "choice": [
                        "moins de 1,5",
                        "1,6 à 5",
                        "5,1 à 10",
                        "plus de 10"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "33900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 337,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Hématologie",
                  "name": "Éosinophiles",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "10exp9 / litre",
                      "choice": [
                        "Moins de 0,5",
                        "0,6 à 1,5",
                        "plus de 1,5"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "34000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 338,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Hématologie",
                  "name": "Polymorphonucléaires neutrophiles",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "10exp9 / litre",
                      "choice": [
                        "moins de 0,5",
                        "0,6 à 1,0",
                        "1,1 à 1,5",
                        "plus de 1,5"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "34100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 339,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Hématologie",
                  "name": "Lymphocytes",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "10exp9 / litre",
                      "choice": [
                        "moins de 0,5",
                        "0,6 à 1,0",
                        "1,1 à 1,5",
                        "plus de 1,5"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "34200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 340,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Hématologie",
                  "name": "Hémoglobine",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "10exp12 / litre",
                      "choice": [
                        "moins de 10 g/L",
                        "10,1 à 14",
                        "plus de 14"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "34300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 341,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Hématologie",
                  "name": "Plaquettes",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "Moins de 100",
                        "plus de 100"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                }
              ]
            },
            {
              "id": "82",
              "label": "Biochimie",
              "index": 342,
              "children": [
                {
                  "id": "34400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 342,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Biochimie",
                  "name": "AST",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "> 2 X N",
                      "choice": [
                        "N",
                        "élevés"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "34500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 343,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Biochimie",
                  "name": "ALT",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "> 2 X N",
                      "choice": [
                        "N",
                        "élevés"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "34600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 344,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Biochimie",
                  "name": "Créatinine",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "nombre",
                      "unit": "umol/L",
                      "choice": "",
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "34700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 345,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Biochimie",
                  "name": "Taux filtration glomérulaire estimé",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "cc/min",
                      "choice": [
                        "moins de 15",
                        "16 à 30",
                        "31 à 60",
                        "61 à 90",
                        "plus de 90"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "34800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 346,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Biochimie",
                  "name": "CRP",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "mg/L",
                      "choice": [
                        "Moins de 3",
                        "4 à 10",
                        "11 à 30",
                        "31 à 50",
                        "51 à 100",
                        "plus de 100"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "34900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 347,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Biochimie",
                  "name": "Vitesse de sédimentation",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "mm/heure",
                      "choice": [
                        "Moins de 25",
                        "26 à 50",
                        "plus de 50"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "35000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 348,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Biochimie",
                  "name": "HbA1C",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "Moins de 6",
                        "6.1 - 7",
                        "7.1 - 8",
                        "Plus de 8"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "35100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 349,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Biochimie",
                  "name": "Protéinurie (bâtonnet ou ratio P :C)",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "g / L",
                      "choice": [
                        "< 0.3",
                        "0.31 - 0.5",
                        "0.51 - 0.99",
                        "≥ 1.0"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                }
              ]
            },
            {
              "id": "83",
              "label": "Sérologies",
              "index": 350,
              "children": [
                {
                  "id": "35200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 350,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Sérologies",
                  "name": "Cryoglobulines",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "présent",
                        "absent"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "35300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 351,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Sérologies",
                  "name": "ANCA (p ou c)",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "p",
                        "c",
                        "absent"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "35400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 352,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Sérologies",
                  "name": "Anti PR3 (présent ou absent)",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "présent",
                        "absent"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "35500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 353,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Sérologies",
                  "name": "Anti MPO (présent ou absent)",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "présent",
                        "absent"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "35600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 354,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Sérologies",
                  "name": "ANA",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "négatif",
                        "1:80 ou moins",
                        "plus de 1:80"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                },
                {
                  "id": "35700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 355,
                  "tab": "Examens paracliniques",
                  "category": "Examens de laboratoire",
                  "subCategory": "Sérologies",
                  "name": "Anticorps antiphospholipides",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Résultat",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "Négatif",
                        "faible titre",
                        "titre moyen ou élevé"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Resultat"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "84",
          "label": "Imagerie diagnostique",
          "index": 356,
          "children": [
            {
              "id": "85",
              "label": "Imagerie diagnostique",
              "index": 356,
              "children": [
                {
                  "id": "35800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 356,
                  "tab": "Examens paracliniques",
                  "category": "Imagerie diagnostique",
                  "subCategory": "Imagerie diagnostique",
                  "name": "Radiographie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Région anatomique",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "cerébral",
                        "sinus",
                        "cou",
                        "poumons",
                        "cardiaque",
                        "abdomen",
                        "pelvien",
                        "musculosquelettique",
                        "artères temporales",
                        "artère faciale",
                        "artère carotide",
                        "artère vertébrale",
                        "artère sous-clavière",
                        "artère axillaire",
                        "tronc innominé",
                        "aorte ascendante",
                        "crosse aortique",
                        "aorte descendante",
                        "aorte abdominale",
                        "artère rénale",
                        "tronc coeliaque",
                        "artère mésentérique supérieure",
                        "artère mésentérique inférieure",
                        "artère iliaque",
                        "artère fémorale",
                        "vasculaire périphérique",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Region anatomique"
                    },
                    {
                      "label": "Description",
                      "type": "choix_multiple_non_ex",
                      "unit": "Imagerie région applicable",
                      "choice": [
                        "pachyméningite",
                        "ischémie cérébrale",
                        "vasculite cérébrale",
                        "inflammation parenchyme cérébral",
                        "hémorragie sous arachnoïdienne",
                        "hémorragie cérébrale",
                        "thrombose veineuse cérébrale",
                        "infiltrats alvéolaires",
                        "Infiltrats interstitiels",
                        "Infiltrats",
                        "nodule(s)",
                        "adénopathies",
                        "cavités",
                        "épanchement pleural",
                        "bronchiectasies",
                        "embolie pulmonaire",
                        "épanchement péricardique",
                        "cardiomyopathie",
                        "sténose vasculaire",
                        "anévrisme",
                        "dilatation",
                        "microanévrismes",
                        "dissection",
                        "Épaisssissement de la paroi vasculaire",
                        "Occlusion vasculaire",
                        "Hypermétabolisme de la paroi vasculaire",
                        "masse",
                        "abcès",
                        "hématome",
                        "ischémie mésentérique",
                        "diverticulite",
                        "infarctus rénal",
                        "Fracture",
                        "Lyse",
                        "Autre"
                      ],
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Description"
                    }
                  ]
                },
                {
                  "id": "35900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 357,
                  "tab": "Examens paracliniques",
                  "category": "Imagerie diagnostique",
                  "subCategory": "Imagerie diagnostique",
                  "name": "Echographie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Région anatomique",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "cerébral",
                        "sinus",
                        "cou",
                        "poumons",
                        "cardiaque",
                        "abdomen",
                        "pelvien",
                        "musculosquelettique",
                        "artères temporales",
                        "artère faciale",
                        "artère carotide",
                        "artère vertébrale",
                        "artère sous-clavière",
                        "artère axillaire",
                        "tronc innominé",
                        "aorte ascendante",
                        "crosse aortique",
                        "aorte descendante",
                        "aorte abdominale",
                        "artère rénale",
                        "tronc coeliaque",
                        "artère mésentérique supérieure",
                        "artère mésentérique inférieure",
                        "artère iliaque",
                        "artère fémorale",
                        "vasculaire périphérique",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Region anatomique"
                    },
                    {
                      "label": "Description",
                      "type": "choix_multiple_non_ex",
                      "unit": "Imagerie région applicable",
                      "choice": [
                        "pachyméningite",
                        "ischémie cérébrale",
                        "vasculite cérébrale",
                        "inflammation parenchyme cérébral",
                        "hémorragie sous arachnoïdienne",
                        "hémorragie cérébrale",
                        "thrombose veineuse cérébrale",
                        "infiltrats alvéolaires",
                        "Infiltrats interstitiels",
                        "Infiltrats",
                        "nodule(s)",
                        "adénopathies",
                        "cavités",
                        "épanchement pleural",
                        "bronchiectasies",
                        "embolie pulmonaire",
                        "épanchement péricardique",
                        "cardiomyopathie",
                        "sténose vasculaire",
                        "anévrisme",
                        "dilatation",
                        "microanévrismes",
                        "dissection",
                        "Épaisssissement de la paroi vasculaire",
                        "Occlusion vasculaire",
                        "Hypermétabolisme de la paroi vasculaire",
                        "masse",
                        "abcès",
                        "hématome",
                        "ischémie mésentérique",
                        "diverticulite",
                        "infarctus rénal",
                        "Fracture",
                        "Lyse",
                        "Autre"
                      ],
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Description"
                    }
                  ]
                },
                {
                  "id": "36000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 358,
                  "tab": "Examens paracliniques",
                  "category": "Imagerie diagnostique",
                  "subCategory": "Imagerie diagnostique",
                  "name": "Tomographie axiale",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Région anatomique",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "cerébral",
                        "sinus",
                        "cou",
                        "poumons",
                        "cardiaque",
                        "abdomen",
                        "pelvien",
                        "musculosquelettique",
                        "artères temporales",
                        "artère faciale",
                        "artère carotide",
                        "artère vertébrale",
                        "artère sous-clavière",
                        "artère axillaire",
                        "tronc innominé",
                        "aorte ascendante",
                        "crosse aortique",
                        "aorte descendante",
                        "aorte abdominale",
                        "artère rénale",
                        "tronc coeliaque",
                        "artère mésentérique supérieure",
                        "artère mésentérique inférieure",
                        "artère iliaque",
                        "artère fémorale",
                        "vasculaire périphérique",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Region anatomique"
                    },
                    {
                      "label": "Description",
                      "type": "choix_multiple_non_ex",
                      "unit": "Imagerie région applicable",
                      "choice": [
                        "pachyméningite",
                        "ischémie cérébrale",
                        "vasculite cérébrale",
                        "inflammation parenchyme cérébral",
                        "hémorragie sous arachnoïdienne",
                        "hémorragie cérébrale",
                        "thrombose veineuse cérébrale",
                        "infiltrats alvéolaires",
                        "Infiltrats interstitiels",
                        "Infiltrats",
                        "nodule(s)",
                        "adénopathies",
                        "cavités",
                        "épanchement pleural",
                        "bronchiectasies",
                        "embolie pulmonaire",
                        "épanchement péricardique",
                        "cardiomyopathie",
                        "sténose vasculaire",
                        "anévrisme",
                        "dilatation",
                        "microanévrismes",
                        "dissection",
                        "Épaisssissement de la paroi vasculaire",
                        "Occlusion vasculaire",
                        "Hypermétabolisme de la paroi vasculaire",
                        "masse",
                        "abcès",
                        "hématome",
                        "ischémie mésentérique",
                        "diverticulite",
                        "infarctus rénal",
                        "Fracture",
                        "Lyse",
                        "Autre"
                      ],
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Description"
                    }
                  ]
                },
                {
                  "id": "36100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 359,
                  "tab": "Examens paracliniques",
                  "category": "Imagerie diagnostique",
                  "subCategory": "Imagerie diagnostique",
                  "name": "Angioscan",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Région anatomique",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "cerébral",
                        "sinus",
                        "cou",
                        "poumons",
                        "cardiaque",
                        "abdomen",
                        "pelvien",
                        "musculosquelettique",
                        "artères temporales",
                        "artère faciale",
                        "artère carotide",
                        "artère vertébrale",
                        "artère sous-clavière",
                        "artère axillaire",
                        "tronc innominé",
                        "aorte ascendante",
                        "crosse aortique",
                        "aorte descendante",
                        "aorte abdominale",
                        "artère rénale",
                        "tronc coeliaque",
                        "artère mésentérique supérieure",
                        "artère mésentérique inférieure",
                        "artère iliaque",
                        "artère fémorale",
                        "vasculaire périphérique",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Region anatomique"
                    },
                    {
                      "label": "Description",
                      "type": "choix_multiple_non_ex",
                      "unit": "Imagerie région applicable",
                      "choice": [
                        "pachyméningite",
                        "ischémie cérébrale",
                        "vasculite cérébrale",
                        "inflammation parenchyme cérébral",
                        "hémorragie sous arachnoïdienne",
                        "hémorragie cérébrale",
                        "thrombose veineuse cérébrale",
                        "infiltrats alvéolaires",
                        "Infiltrats interstitiels",
                        "Infiltrats",
                        "nodule(s)",
                        "adénopathies",
                        "cavités",
                        "épanchement pleural",
                        "bronchiectasies",
                        "embolie pulmonaire",
                        "épanchement péricardique",
                        "cardiomyopathie",
                        "sténose vasculaire",
                        "anévrisme",
                        "dilatation",
                        "microanévrismes",
                        "dissection",
                        "Épaisssissement de la paroi vasculaire",
                        "Occlusion vasculaire",
                        "Hypermétabolisme de la paroi vasculaire",
                        "masse",
                        "abcès",
                        "hématome",
                        "ischémie mésentérique",
                        "diverticulite",
                        "infarctus rénal",
                        "Fracture",
                        "Lyse",
                        "Autre"
                      ],
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Description"
                    }
                  ]
                },
                {
                  "id": "36200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 360,
                  "tab": "Examens paracliniques",
                  "category": "Imagerie diagnostique",
                  "subCategory": "Imagerie diagnostique",
                  "name": "Résonance magnétique (IRM)",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Région anatomique",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "cerébral",
                        "sinus",
                        "cou",
                        "poumons",
                        "cardiaque",
                        "abdomen",
                        "pelvien",
                        "musculosquelettique",
                        "artères temporales",
                        "artère faciale",
                        "artère carotide",
                        "artère vertébrale",
                        "artère sous-clavière",
                        "artère axillaire",
                        "tronc innominé",
                        "aorte ascendante",
                        "crosse aortique",
                        "aorte descendante",
                        "aorte abdominale",
                        "artère rénale",
                        "tronc coeliaque",
                        "artère mésentérique supérieure",
                        "artère mésentérique inférieure",
                        "artère iliaque",
                        "artère fémorale",
                        "vasculaire périphérique",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Region anatomique"
                    },
                    {
                      "label": "Description",
                      "type": "choix_multiple_non_ex",
                      "unit": "Imagerie région applicable",
                      "choice": [
                        "pachyméningite",
                        "ischémie cérébrale",
                        "vasculite cérébrale",
                        "inflammation parenchyme cérébral",
                        "hémorragie sous arachnoïdienne",
                        "hémorragie cérébrale",
                        "thrombose veineuse cérébrale",
                        "infiltrats alvéolaires",
                        "Infiltrats interstitiels",
                        "Infiltrats",
                        "nodule(s)",
                        "adénopathies",
                        "cavités",
                        "épanchement pleural",
                        "bronchiectasies",
                        "embolie pulmonaire",
                        "épanchement péricardique",
                        "cardiomyopathie",
                        "sténose vasculaire",
                        "anévrisme",
                        "dilatation",
                        "microanévrismes",
                        "dissection",
                        "Épaisssissement de la paroi vasculaire",
                        "Occlusion vasculaire",
                        "Hypermétabolisme de la paroi vasculaire",
                        "masse",
                        "abcès",
                        "hématome",
                        "ischémie mésentérique",
                        "diverticulite",
                        "infarctus rénal",
                        "Fracture",
                        "Lyse",
                        "Autre"
                      ],
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Description"
                    }
                  ]
                },
                {
                  "id": "36300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 361,
                  "tab": "Examens paracliniques",
                  "category": "Imagerie diagnostique",
                  "subCategory": "Imagerie diagnostique",
                  "name": "Angio IRM",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Région anatomique",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "cerébral",
                        "sinus",
                        "cou",
                        "poumons",
                        "cardiaque",
                        "abdomen",
                        "pelvien",
                        "musculosquelettique",
                        "artères temporales",
                        "artère faciale",
                        "artère carotide",
                        "artère vertébrale",
                        "artère sous-clavière",
                        "artère axillaire",
                        "tronc innominé",
                        "aorte ascendante",
                        "crosse aortique",
                        "aorte descendante",
                        "aorte abdominale",
                        "artère rénale",
                        "tronc coeliaque",
                        "artère mésentérique supérieure",
                        "artère mésentérique inférieure",
                        "artère iliaque",
                        "artère fémorale",
                        "vasculaire périphérique",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Region anatomique"
                    },
                    {
                      "label": "Description",
                      "type": "choix_multiple_non_ex",
                      "unit": "Imagerie région applicable",
                      "choice": [
                        "pachyméningite",
                        "ischémie cérébrale",
                        "vasculite cérébrale",
                        "inflammation parenchyme cérébral",
                        "hémorragie sous arachnoïdienne",
                        "hémorragie cérébrale",
                        "thrombose veineuse cérébrale",
                        "infiltrats alvéolaires",
                        "Infiltrats interstitiels",
                        "Infiltrats",
                        "nodule(s)",
                        "adénopathies",
                        "cavités",
                        "épanchement pleural",
                        "bronchiectasies",
                        "embolie pulmonaire",
                        "épanchement péricardique",
                        "cardiomyopathie",
                        "sténose vasculaire",
                        "anévrisme",
                        "dilatation",
                        "microanévrismes",
                        "dissection",
                        "Épaisssissement de la paroi vasculaire",
                        "Occlusion vasculaire",
                        "Hypermétabolisme de la paroi vasculaire",
                        "masse",
                        "abcès",
                        "hématome",
                        "ischémie mésentérique",
                        "diverticulite",
                        "infarctus rénal",
                        "Fracture",
                        "Lyse",
                        "Autre"
                      ],
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Description"
                    }
                  ]
                },
                {
                  "id": "36400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 362,
                  "tab": "Examens paracliniques",
                  "category": "Imagerie diagnostique",
                  "subCategory": "Imagerie diagnostique",
                  "name": "Angiographie conventionnelle",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Région anatomique",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "cerébral",
                        "sinus",
                        "cou",
                        "poumons",
                        "cardiaque",
                        "abdomen",
                        "pelvien",
                        "musculosquelettique",
                        "artères temporales",
                        "artère faciale",
                        "artère carotide",
                        "artère vertébrale",
                        "artère sous-clavière",
                        "artère axillaire",
                        "tronc innominé",
                        "aorte ascendante",
                        "crosse aortique",
                        "aorte descendante",
                        "aorte abdominale",
                        "artère rénale",
                        "tronc coeliaque",
                        "artère mésentérique supérieure",
                        "artère mésentérique inférieure",
                        "artère iliaque",
                        "artère fémorale",
                        "vasculaire périphérique",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Region anatomique"
                    },
                    {
                      "label": "Description",
                      "type": "choix_multiple_non_ex",
                      "unit": "Imagerie région applicable",
                      "choice": [
                        "pachyméningite",
                        "ischémie cérébrale",
                        "vasculite cérébrale",
                        "inflammation parenchyme cérébral",
                        "hémorragie sous arachnoïdienne",
                        "hémorragie cérébrale",
                        "thrombose veineuse cérébrale",
                        "infiltrats alvéolaires",
                        "Infiltrats interstitiels",
                        "Infiltrats",
                        "nodule(s)",
                        "adénopathies",
                        "cavités",
                        "épanchement pleural",
                        "bronchiectasies",
                        "embolie pulmonaire",
                        "épanchement péricardique",
                        "cardiomyopathie",
                        "sténose vasculaire",
                        "anévrisme",
                        "dilatation",
                        "microanévrismes",
                        "dissection",
                        "Épaisssissement de la paroi vasculaire",
                        "Occlusion vasculaire",
                        "Hypermétabolisme de la paroi vasculaire",
                        "masse",
                        "abcès",
                        "hématome",
                        "ischémie mésentérique",
                        "diverticulite",
                        "infarctus rénal",
                        "Fracture",
                        "Lyse",
                        "Autre"
                      ],
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Description"
                    }
                  ]
                },
                {
                  "id": "36500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 363,
                  "tab": "Examens paracliniques",
                  "category": "Imagerie diagnostique",
                  "subCategory": "Imagerie diagnostique",
                  "name": "Scintigraphie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Région anatomique",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "cerébral",
                        "sinus",
                        "cou",
                        "poumons",
                        "cardiaque",
                        "abdomen",
                        "pelvien",
                        "musculosquelettique",
                        "artères temporales",
                        "artère faciale",
                        "artère carotide",
                        "artère vertébrale",
                        "artère sous-clavière",
                        "artère axillaire",
                        "tronc innominé",
                        "aorte ascendante",
                        "crosse aortique",
                        "aorte descendante",
                        "aorte abdominale",
                        "artère rénale",
                        "tronc coeliaque",
                        "artère mésentérique supérieure",
                        "artère mésentérique inférieure",
                        "artère iliaque",
                        "artère fémorale",
                        "vasculaire périphérique",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Region anatomique"
                    },
                    {
                      "label": "Description",
                      "type": "choix_multiple_non_ex",
                      "unit": "Imagerie région applicable",
                      "choice": [
                        "pachyméningite",
                        "ischémie cérébrale",
                        "vasculite cérébrale",
                        "inflammation parenchyme cérébral",
                        "hémorragie sous arachnoïdienne",
                        "hémorragie cérébrale",
                        "thrombose veineuse cérébrale",
                        "infiltrats alvéolaires",
                        "Infiltrats interstitiels",
                        "Infiltrats",
                        "nodule(s)",
                        "adénopathies",
                        "cavités",
                        "épanchement pleural",
                        "bronchiectasies",
                        "embolie pulmonaire",
                        "épanchement péricardique",
                        "cardiomyopathie",
                        "sténose vasculaire",
                        "anévrisme",
                        "dilatation",
                        "microanévrismes",
                        "dissection",
                        "Épaisssissement de la paroi vasculaire",
                        "Occlusion vasculaire",
                        "Hypermétabolisme de la paroi vasculaire",
                        "masse",
                        "abcès",
                        "hématome",
                        "ischémie mésentérique",
                        "diverticulite",
                        "infarctus rénal",
                        "Fracture",
                        "Lyse",
                        "Autre"
                      ],
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Description"
                    }
                  ]
                },
                {
                  "id": "36600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 364,
                  "tab": "Examens paracliniques",
                  "category": "Imagerie diagnostique",
                  "subCategory": "Imagerie diagnostique",
                  "name": "TEP",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Région anatomique",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "cerébral",
                        "sinus",
                        "cou",
                        "poumons",
                        "cardiaque",
                        "abdomen",
                        "pelvien",
                        "musculosquelettique",
                        "artères temporales",
                        "artère faciale",
                        "artère carotide",
                        "artère vertébrale",
                        "artère sous-clavière",
                        "artère axillaire",
                        "tronc innominé",
                        "aorte ascendante",
                        "crosse aortique",
                        "aorte descendante",
                        "aorte abdominale",
                        "artère rénale",
                        "tronc coeliaque",
                        "artère mésentérique supérieure",
                        "artère mésentérique inférieure",
                        "artère iliaque",
                        "artère fémorale",
                        "vasculaire périphérique",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Region anatomique"
                    },
                    {
                      "label": "Description",
                      "type": "choix_multiple_non_ex",
                      "unit": "Imagerie région applicable",
                      "choice": [
                        "pachyméningite",
                        "ischémie cérébrale",
                        "vasculite cérébrale",
                        "inflammation parenchyme cérébral",
                        "hémorragie sous arachnoïdienne",
                        "hémorragie cérébrale",
                        "thrombose veineuse cérébrale",
                        "infiltrats alvéolaires",
                        "Infiltrats interstitiels",
                        "Infiltrats",
                        "nodule(s)",
                        "adénopathies",
                        "cavités",
                        "épanchement pleural",
                        "bronchiectasies",
                        "embolie pulmonaire",
                        "épanchement péricardique",
                        "cardiomyopathie",
                        "sténose vasculaire",
                        "anévrisme",
                        "dilatation",
                        "microanévrismes",
                        "dissection",
                        "Épaisssissement de la paroi vasculaire",
                        "Occlusion vasculaire",
                        "Hypermétabolisme de la paroi vasculaire",
                        "masse",
                        "abcès",
                        "hématome",
                        "ischémie mésentérique",
                        "diverticulite",
                        "infarctus rénal",
                        "Fracture",
                        "Lyse",
                        "Autre"
                      ],
                      "key": "d3",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Description"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "86",
          "label": "Résultats de la Biopsie",
          "index": 365,
          "children": [
            {
              "id": "87",
              "label": "Résultats de la Biopsie",
              "index": 365,
              "children": [
                {
                  "id": "36700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 365,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Peau",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "36800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 366,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Cérébrale",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "36900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 367,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Méninges",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "37000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 368,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Sinus",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "37100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 369,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Larynx",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "37200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 370,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Nasale",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "37300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 371,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Pulmonaire",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "37400",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 372,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Cardiaque",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "37500",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 373,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Gastrique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "37600",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 374,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Colon",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "37700",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 375,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Intestin grêle",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "37800",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 376,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Foie",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "37900",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 377,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Rein",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "38000",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 378,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Nerf périphérique",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "38100",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 379,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Muscle",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "38200",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 380,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Artère temporale",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                },
                {
                  "id": "38300",
                  "timeRule": "dV,d1;d1>d1",
                  "index": 381,
                  "tab": "Examens paracliniques",
                  "category": "Résultats de la Biopsie",
                  "subCategory": "Résultats de la Biopsie",
                  "name": "Autre",
                  "labelItem": null,
                  "labelVisit": null,
                  "orderByField": "d1",
                  "isMultiple": true,
                  "prefixForMultiple": "",
                  "noteToUser": "",
                  "additionalData": [
                    {
                      "label": "Date du test, si différente",
                      "type": "date",
                      "unit": "",
                      "choice": "",
                      "key": "d1",
                      "typeRules": "warnIfAbsent",
                      "fieldName": "Date du test, si differente"
                    },
                    {
                      "label": "Trouvaille",
                      "type": "choix_multiples",
                      "unit": "",
                      "choice": [
                        "infectieux",
                        "néoplasie",
                        "inflammation granulomateuse",
                        "nécrose",
                        "thrombose",
                        "vasculite d’artère musculaire",
                        "vasculite d’artère élastique",
                        "capillarite",
                        "glomérulonéphrite",
                        "hémorragie",
                        "inflammation non spécifique",
                        "changements fibrocicatritiels",
                        "normale",
                        "amyloÏdose",
                        "athérosclérose",
                        "cellules géantes",
                        "immunofluorescence positive",
                        "immunofluorescence négative",
                        "autre"
                      ],
                      "key": "d2",
                      "typeRules": "failIfAbsent,veuillez spécifier",
                      "fieldName": "Trouvaille"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}